import findResult, { removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import datasetSettingActions from '../../settings/constants';
import actions from '../../constants';
import { findAllDatasourceFeatures, findAllDatasourceSettings, findDatasourceFeature } from './state';

const destroyDatasourceFeatures = (draft, action) => {
  findAllDatasourceFeatures(draft, action).forEach((category) => {
    action.items.forEach(({ code }) => {
      const item = findResult(draft.features, category, code);
      if (item) {
        draft.features[category].results = removeItemByCode(draft.features[category].results, item);
      }
    });
  });
};

const destroyDatasoureSettings = (draft, action) => {
  findAllDatasourceSettings(draft, action).forEach((category) => {
    action.items.forEach(({ code }) => {
      const item = findResult(draft.settings, category, code);
      if (item) {
        draft.settings[category].results = removeItemByCode(draft.settings[category].results, item);
      }
    });
  });
};

const destroyDatasetDependencies = withDraft((draft, action) => {
  destroyDatasoureSettings(draft, action);
  destroyDatasourceFeatures(draft, action);
});

const cancelDatasetSettings = withDraft((draft, action) => {
  destroyDatasoureSettings(draft, { items: [action] });
});

const closeDatasourceFeatures = withDraft((draft, action) => {
  const item = findDatasourceFeature(draft, action);
  if (item) {
    draft.features[action.category].results = removeItemByCode(draft.features[action.category].results, item);
  }
});

export default {
  [actions.CLOSE_DATASET]: closeDatasourceFeatures,
  [actions.DESTROY_DATASET]: destroyDatasetDependencies,
  [actions.UPDATE_DATASET_CANCEL]: cancelDatasetSettings,
  [datasetSettingActions.CLOSE_DATASET_SETTINGS]: closeDatasourceFeatures,
};
